module.exports = __webpack_public_path__ + "img/company-list.b25b6853.png";